module.exports = __webpack_public_path__ + "static/img/sam-cover@2x.e88b0543.png";